import Treatment from './container'

export default Treatment
